import React, { useEffect, useState } from 'react';
import counterpart from 'counterpart';
import Button from '../../../components/ui/button/Button';
import { fetchCompanyTrialBalance, updateCompanyTrialLimit } from '../../../actions/companiesActions';
import Panel from '../../../components/ui/panel/Panel';
import FormGroup from '../../../components/ui/form-group/FormGroup';
import { Row, Col } from 'react-grid-system';
import FormLabel from '../../../components/ui/form-label/FormLabel';
import Input from '../../../components/ui/input/Input';
import { multiplyNumberBy100, divideNumberBy100 } from '../../../utils/commonUtils';
import ErrorNotification from '../../ui/error-notification/ErrorNotification';
import { GeTrialBalanceResponse } from '../../../utils/grpc/generated/Billsby.Protos/revenues/private/company/company_pb';
import { connect } from 'react-redux';
import ProgressIndicator from '../../ui/progress-indicator/ProgressIndicator';


interface IExtendTrial {
  companyId?: number,
  callBack: () => void,
  dispatch: Function,
}

const ExtendTrial: React.FC<IExtendTrial> = ({ companyId, callBack, dispatch }) => {

  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [trialLimit, setTrialLimit] = useState<GeTrialBalanceResponse | undefined>(undefined);
  const [newTrialLimit, setNewTrialLimit] = useState<number | undefined>(undefined);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoadingData(true);
        const { response: _trialLimit } = await dispatch(fetchCompanyTrialBalance(companyId as number))
        setTrialLimit(_trialLimit as GeTrialBalanceResponse);
        setNewTrialLimit(!!_trialLimit ? divideNumberBy100(_trialLimit.getTrialLimit()) : undefined);
      }
      catch(err) {
        setHasError(true)
      }
      finally {
        setIsLoadingData(false);
      }
    }

    fetchData();

  }, []);

  if(isLoadingData) {
    return <ProgressIndicator color="blue" coverage='normal' />
  }
  
  return (
    <>
    <ErrorNotification
      title="ERROR_OCCURED"
      isModal={true}
      showAlert={hasError}
      showButton={false}
      showSubtitle={false}
      onClose={() => setHasError(false)} />

      <Panel>
        <FormGroup className="companies__extend-trial">
          <Row>
            <Col xs={12}>
              <div className="companies__extend-trial__formgroup">
                <FormLabel target="email-input" content="EXTEND_TRIAL_MODAL_TRIAL_LIMIT" />
                <Input
                  required
                  type="number"
                  id="trial-limit-input"
                  placeholder={counterpart("EXTEND_TRIAL_MODAL_TRIAL_LIMIT_PLACEHOLDER")}
                  value={newTrialLimit}
                  onChange={(evt: any) => setNewTrialLimit(evt.target.value === "" ? undefined : evt.target.value)}
                />
              </div>
            </Col>
          </Row>
        </FormGroup>
        
        <FormGroup className="companies__extend-trial noMargin">
          <Row>
            <Col xs={12}>
              <div className="companies__extend-trial__formgroup">
                <FormLabel target="email-input" content="EXTEND_TRIAL_MODAL_TRIAL_BALANCE" />
                <Input
                  required
                  type="number"
                  disabled={true}
                  id="trial-balance-input"
                  value={!!trialLimit ? divideNumberBy100(trialLimit.getTrialBalance()) : undefined}
                />
              </div>
            </Col>
          </Row>
        </FormGroup>
      </Panel>

      {/* <Button
        id="trial-remaining-btn"
        title="EXTEND_TRIAL_MODAL_TRIAL_REMAINING_BUTTON"
        disabled={(Number(newTrialLimit) < 0) || newTrialLimit === undefined || isLoading}
        isLoading={isLoading}
        isFullWidth
        onClick={() => {
          setIsLoading(true);
          dispatch(updateCompanyTrialLimit(companyId as number, multiplyNumberBy100(newTrialLimit) as number))
            .then((res: any) => 
            {
              setIsLoading(false);
              !!res.error ? setHasError(true) : callBack();
            })
            .catch(() => setHasError(true))
        }}
        type="submit"
      /> */}
    </>
  )
}

export default connect()(ExtendTrial);
